import NEWYORK from "../assets/newyork.jpg";
// import BOSTON from "../assets/boston.jpg";
// import RIDGEMARK from "../assets/homepage/ridgemark.png";
import FLORIDA from "../assets/florida.jpg";
import CALIFORNIA from "../assets/california.jpg";
import SANFRANCISCO from "../assets/SanFrancisco.jpg";
import VIRGINIA from "../assets/virginia.jpg";
// import BEVERLY from "../assets/beverly.jpg";
import MENLO from "../assets/homepage/menlo.png";
import JOSE from "../assets/jose.jpg";
// import OAK from "../assets/oak.jpg";
import OAKLAND from "../assets/homepage/oakland.png";
import PALOALTO from "../assets/homepage/paloalto.png";

import learnToSell from "../assets/brokerage/learn-to-sell.png";
import learnToAnalyze from "../assets/brokerage/learn-to-analyze.png";
import advertiseAgents from "../assets/brokerage/advertise-agent.png";
import beAnInvestor from "../assets/agents/Placeholder-successfulInvestor.png";

export const hoods = [
  { city: "San Jose", img: JOSE },
  { city: "Menlo Park", img: MENLO },
  { city: "Palo Alto", img: PALOALTO },
  // { city: "Ridgemark", img: RIDGEMARK },
  { city: "Merced", img: FLORIDA },
  { city: "Oakland", img: OAKLAND },
  { city: "Monterey", img: VIRGINIA },
  { city: "Fremont", img: NEWYORK },
  { city: "Redwood City", img: CALIFORNIA },
  { city: "San Francisco", img: SANFRANCISCO },
];

export const cities = [
  "palo alto",
  "san jose",
  "menlo park",
  "mountain view",
  "san diego",
  "san francisco",
  "santa clara",
  "san mateo",
  "san marco",
  "santa monica",
  "lake forest",
  "san ramon",
  "redwood city",
  "los altos",
  "los palmes",
];

export const states = ["California", "Massachusetts", "New York"];
export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];
export const statesShort = [
  {
    label: "Alaska",
    value: "AK",
  },
  {
    label: "Alabama",
    value: "AL",
  },
  {
    label: "Arkansas",
    value: "AR",
  },
  {
    label: "Arizona",
    value: "AZ",
  },
  {
    label: "California",
    value: "CA",
  },
  {
    label: "Colorado",
    value: "CO",
  },
  {
    label: "Connecticut",
    value: "CT",
  },
  {
    label: "Delaware",
    value: "DE",
  },
  {
    label: "Florida",
    value: "FL",
  },
  {
    label: "Georgia",
    value: "GA",
  },
  {
    label: "Hawaii",
    value: "HI",
  },
  {
    label: "Iowa",
    value: "IA",
  },
  {
    label: "Idaho",
    value: "ID",
  },
  {
    label: "Illinois",
    value: "IL",
  },
  {
    label: "Indiana",
    value: "IN",
  },
  {
    label: "Kansas",
    value: "KS",
  },
  {
    label: "Kentucky",
    value: "KY",
  },
  {
    label: "Louisiana",
    value: "LA",
  },
  {
    label: "Massachusetts",
    value: "MA",
  },
  {
    label: "Maryland",
    value: "MD",
  },
  {
    label: "Maine",
    value: "ME",
  },
  {
    label: "Michigan",
    value: "MI",
  },
  {
    label: "Minnesota",
    value: "MN",
  },
  {
    label: "Missouri",
    value: "MO",
  },
  {
    label: "Mississippi",
    value: "MS",
  },
  {
    label: "Montana",
    value: "MT",
  },
  {
    label: "North Carolina",
    value: "NC",
  },
  {
    label: "North Dakota",
    value: "ND",
  },
  {
    label: "Nebraska",
    value: "NE",
  },
  {
    label: "New Hampshire",
    value: "NH",
  },
  {
    label: "New Jersey",
    value: "NJ",
  },
  {
    label: "New Mexico",
    value: "NM",
  },
  {
    label: "Nevada",
    value: "NV",
  },
  {
    label: "New York",
    value: "NY",
  },
  {
    label: "Ohio",
    value: "OH",
  },
  {
    label: "Oklahoma",
    value: "OK",
  },
  {
    label: "Oregon",
    value: "OR",
  },
  {
    label: "Pennsylvania",
    value: "PA",
  },
  {
    label: "Rhode Island",
    value: "RI",
  },
  {
    label: "South Carolina",
    value: "SC",
  },
  {
    label: "South Dakota",
    value: "SD",
  },
  {
    label: "Tennessee",
    value: "TN",
  },
  { label: "Texas", value: "TX" },
  {
    label: "Utah",
    value: "UT",
  },
  {
    label: "Virginia",
    value: "VA",
  },
  {
    label: "Vermont",
    value: "VT",
  },
  {
    label: "Washington",
    value: "WA",
  },
  {
    label: "Wisconsin",
    value: "WI",
  },
  {
    label: "West Virginia",
    value: "WV",
  },
  {
    label: "Wyoming",
    value: "WY",
  },
];

export const URL = process.env.REACT_APP_URL;
const hardCodedURL = window?.location?.hostname?.includes("testing")
  ? "https://broker-center-testing-api.bpohomes.com/"
  : "https://broker-center-api.bpohomes.com/";

export const BROKER_URL = process.env.REACT_APP_BROKER_BASE_URL || hardCodedURL;

export const timeData = [
  "7:00 AM",
  "7:30 AM",
  "8:00 AM",
  "8:30 AM",
  "9:00 AM",
  "9:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "1:00 PM",
  "1:30 PM",
  "2:00 PM",
  "2:30 PM",
  "3:00 PM",
  "3:30 PM",
  "4:00 PM",
  "4:30 PM",
  "5:00 PM",
  "5:30 PM",
  "6:00 PM",
  "6:30 PM",
  "7:00 PM",
  "7:30 PM",
  "8:00 PM",
];

export const resources = {
  headerTitle: "Resources",
  route: "",
  option: [
    {
      text: "Buyer's checklist",
      route: "",
    },
    {
      text: "Resource center",
      route: "",
    },
    {
      text: "First timer",
      route: "",
    },
    {
      text: "Housing market",
      route: "",
    },
  ],
};

export const propertyList = {
  roof: "Tile",
  cooling: null,
  style: "Traditional",
  area: 1043,
  bathsFull: 5,
  bathsHalf: 6,
  stories: 3,
  fireplaces: 1,
  flooring: null,
  heating: "Radiant Heat",
  bathrooms: null,
  foundation: "Slab",
  laundryFeatures: "Area,Electric Dryer Hookup,Individual Room,Washer Hookup",
  occupantName: null,
  ownerName: null,
  lotDescription: "Private Backyard",
  pool: "Association,Private,In Ground",
  subType: null,
  bedrooms: 2,
  interiorFeatures:
    "Drapes/Curtains/Window Cover, Fire/Smoke Alarm, High Ceiling, Island Kitchen",
  lotSize: "127X146",
  areaSource: "Floorplans",
  maintenanceExpense: null,
  additionalRooms: "Recreation,Master Bedroom,See Remarks",
  exteriorFeatures: "Back Yard Fenced, Covered Patio/Deck, Patio/Deck",
  water: null,
  view: "Golf Course",
  lotSizeArea: null,
  subdivision: "Waterstone Springs",
  construction: "In Kitchen,Stackable,Washer Included",
  lotSizeAreaUnits: null,
  type: "RES",
  garageSpaces: 8.74556425245327,
  bathsThreeQuarter: null,
  accessibility: "Manned Gate",
  acres: null,
  occupantType: null,
  subTypeText: null,
  yearBuilt: 1998,
};

export const quesLists = [
  [
    {
      title: "When do you plan on selling?",
      subTitle: "Please tell us your ideal timeline for closing the sale.",
      options: [
        "ASAP",
        "6 - 12 months",
        "1 - 3 months",
        "12+ months",
        "3 - 6 months",
      ],
      formID: "sellingPlan",
    },
  ],
  [
    {
      title: "What is the current condition of your home?",
      subTitle: "Please select an answer",
      options: ["Needs Significant work", "Needs a little work", "Tear down"],
      formID: "currentCondition",
    },
  ],
  [
    {
      title: "Why are you selling your home?",
      subTitle: "Please select an answer",
      options: [
        "Upgrading my home",
        "Downsizing my home",
        "Selling secondary home",
        "Retiring",
        "Relocating",
        "Other",
      ],
      formID: "whySell",
    },
  ],
  [
    {
      title: "Are you currently working with a real estate agent? ",
      subTitle: "Please select an answer",
      options: ["Yes", "No"],
      formID: "haveAnAgent",
    },
  ],
  [
    {
      title: "Are you also looking to buy a home?",
      subTitle: "Please select an answer",
      options: ["Yes", "No"],
      formID: "wantToBuyAHome",
    },
  ],
  [
    {
      title: "Have you made any improvements to your home?",
      subTitle: "Please provide any improvement made",
      options: "improvementForm",
    },
  ],
  [
    {
      title: "We’ll like to know you more:",
      subTitle: "",
      options: "personalDetailsForm",
    },
  ],
];

export const listingDetails = [
  {
    key: "Listing Type",
    value: "subTypeText",
  },
  {
    key: "Occupant Type",
    value: "occupantType",
  },
  {
    key: "Year Built",
    value: "yearBuilt",
  },
  {
    key: "Structure Sq Ft",
    value: "area",
  },
  {
    key: "Lot Acres",
    value: "acres",
  },
  {
    key: "Lot Size Area",
    value: "lotSizeArea",
  },
  {
    key: "Lot Size Area Units",
    value: "lotSizeAreaUnits",
  },
  {
    key: "Zoning",
    value: "zoning",
  },
];

export const interiorDetails = [
  {
    key: "Total Bedrooms",
    value: "bedrooms",
  },
  {
    key: "# of Baths (Full)",
    value: "bathsFull",
  },
  {
    key: "# of Baths (Half)",
    value: "bathsHalf",
  },
  {
    key: "Fireplace Min",
    value: "fireplaces",
  },
  {
    key: "Interior Features",
    value: "interiorFeatures",
  },
  {
    key: "Heating",
    value: "heating",
  },
  {
    key: "Cooling",
    value: "cooling",
  },
  {
    key: "Flooring",
    value: "flooring",
  },
  {
    key: "Stories",
    value: "stories",
  },
  {
    key: "Laundry Features",
    value: "laundryFeatures",
  },
  {
    key: "Accessibility",
    value: "accessibility",
  },
];

export const exteriorDetails = [
  {
    key: "Style",
    value: "style",
  },
  {
    key: "Roof",
    value: "roof",
  },
  {
    key: "Foundation",
    value: "foundation",
  },
  {
    key: "Pool",
    value: "pool",
  },
  {
    key: "Construction",
    value: "flooring",
  },
  {
    key: "Lot Description",
    value: "lotDescription",
  },
  {
    key: "Exterior Features",
    value: "exteriorFeatures",
  },
  {
    key: "Water",
    value: "water",
  },
  {
    key: "View",
    value: "view",
  },
  {
    key: "Construction",
    value: "construction",
  },
  {
    key: "Horse YN",
    value: "horseYN",
  },
  {
    key: "Sewer",
    value: "sewer",
  },
  {
    key: "Utilities",
    value: "utilities",
  },
];

export const garageDetails = [
  {
    key: "Garage Spaces",
    value: "garageSpaces",
  },
  {
    key: "Parking Spaces",
    value: "spaces",
  },
  {
    key: "Parking Features",
    value: "description",
  },
  {
    key: "Garage Min",
    value: "garageSpaces",
  },
  {
    key: "Garage Max",
    value: "garageSpaces",
  },
];

export const infoboxTemplate = (src, price, address) => {
  //img
  let img = document.createElement("img");
  img.style.height = "10rem";
  img.src = src;
  //price
  let head5 = document.createElement("h5");
  let text = document.createTextNode(price);
  head5.appendChild(text);
  // address
  let p = document.createElement("p");
  let addr = document.createTextNode(address);
  p.appendChild(addr);

  var box = document.querySelector("InfoboxCustom");
  box.appendChild(img, head5, p);
};

export const option1 = [
  "Phone Numbers & Emails",
  "Premier Agent Advertising",
  "NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited",
  "Divorce Leads Unlimited",
  "Probate Leads Unlimited",
  "FSBO (For Sale By Owner) Leads Unlimited",
  "Expired Leads Unlimited",
  "Canceled Leads Unlimited",
  "Tax License",
  "Withdrawn Leads Unlimited",
  "Deal Analyzer Access Unlimited",
  "BPO Tech Training Center Access",
  "BPO Report Ordering Page",
  "Luxury Investor Website",
  "Investor Log (Investor List Available for Purchase)",
  "MDA (Million Dollar Agent) Business Program",
  "20% Referral Fee Required for Premier Agent Leads",
  "Pre-Qualified Leads",
  "Go High Level CRM Pro Edge Included",
  "Life Insurance Licensing Fee Add On",
  "MLO Licensing Fee Add On",
];

export const option2 = [
  "Phone Numbers & Emails",
  "Premier Agent Advertising",
  "Marketing to 2000 Sellers",
  "Seller Calls Performed Quarterly",
  "Seller Texts Performed Quarterly",
  "Seller Emails Performed Monthly (Marketing Designs Included)",
  "Realty Agent Advertising",
  "NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited",
  "Divorce Leads Unlimited",
  "Probate Leads Unlimited",
  "FSBO (For Sale By Owner) Leads Unlimited",
  "Expired Leads Unlimited",
  "Canceled Leads Unlimited",
  "Tax License",
  "Withdrawn Leads Unlimited",
  "Deal Analyzer Access",
  "Unlimited BPO Tech Training Center Access",
  "BPO Report Ordering Page",
  "Luxury Investor Website",
  "Investor Log (Investor List Available for Purchase)",
  "MDA (Million Dollar Agent) Business Program",
  "20% Referral Fee Required for Premier Agent Leads",
  "Go High Level CRM Pro Edge Included",
  "Life Insurance Licensing Fee Add On",
  "MLO Licensing Fee Add On",
];

export const option3 = [
  "Phone Numbers & Emails",
  "Premier Agent Advertising",
  "Marketing to 3000 Sellers",
  "Seller Calls Performed Quarterly",
  "Seller Texts Performed Quarterly",
  "Seller Emails Performed Monthly (Marketing Designs Included)",
  "Realty Agent Advertising",
  "NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited",
  "Divorce Leads Unlimited",
  "Probate Leads Unlimited",
  "FSBO (For Sale By Owner) Leads Unlimited",
  "Expired Leads Unlimited",
  "Canceled Leads Unlimited",
  "Tax License",
  "Withdrawn Leads Unlimited",
  "Deal Analyzer Access",
  "Unlimited BPO Tech Training Center Access",
  "BPO Report Ordering Page",
  "Luxury Investor Website",
  "Investor Log (Investor List Available for Purchase)",
  "30% Referral Fee Required for Premier Agent Leads",
  "30% Referral Fee from VA Leads",
  "Go High Level CRM Pro Edge Included",
  "1 Guarantee Pre-Qualify Leads per Month",
  "Life Insurance Licensing Fee Add On",
  "MLO Licensing Fee Add On",
];
export const option4 = [
  "Premier Agent Advertising",
  "Marketing to 4000 Sellers",
  "Seller Calls Performed Quarterly",
  "Seller Texts Performed Quarterly",
  "Seller Emails Performed Monthly (Marketing Designs Included)",
  "Realty Agent Advertising",
  "NOD (Notice of Default / Pre-Foreclosure) Leads Unlimited",
  "Divorce Leads Unlimited",
  "Probate Leads Unlimited",
  "FSBO (For Sale By Owner) Leads Unlimited",
  "Expired Leads Unlimited",
  "Canceled Leads Unlimited",
  "Withdrawn Leads Unlimited",
  "Deal Analyzer Access",
  "Unlimited BPO Tech Training Center Access",
  "BPO Report Ordering Page",
  "Luxury Investor Website",
  "Investor Log (Investor List Available for Purchase)",
  "MDA (Million Dollar Agent) Business Program",
  "20% Referral Fee Required for Premier Agent Leads",
  "20% Referral Fee from VA Leads",
  "Go High Level CRM Pro Edge Included",
  "1 Guarantee Pre-Qualify Leads per Month",
  "Life Insurance Licensing Fee Add On",
  "MLO Licensing Fee Add On",
];

export const maxPrice = 10000000;
export const minPrice = 0;
export const token = {
  username: "opera_1k43ox5s",
  password: "69m461h165333265",
};

export const scrollUp = () => {
  const element = document.getElementById("scrollRef");
  element.scrollIntoView();
};

export const specialties = [
  "",
  "Buyer Agent",
  "Listing Agent",
  "Relocation",
  "Short Sale",
  "Foreclosure",
  "Consulting",
  "Other",
];
export const languages = [
  "",
  "English",
  "Spanish",
  "French",
  "German",
  "Mandarin",
  "Cantonese",
  "Arabic",
  "Hindi",
  "Polish",
  "Italian",
  "Thai",
  "Korean",
  "Greek",
];

export const mapLibraries = ["places"];

export const gotoLinks = [
  {
    id: "overview",
    name: "Overview",
  },
  {
    id: "propertyDetails",
    name: "Property Details",
  },
  {
    id: "neighborhood",
    name: "Neighborhood",
  },
  {
    id: "nearby",
    name: "Nearby",
  },
];
export const agentUpdateForm = [
  {
    label: "Agent First Name",
    name: "first_name",
    type: "text",
    placeholder: "Agent First name",
    validation: {
      required: "Agent firstname is required",
    },
  },
  {
    label: "Agent Last Name",
    name: "last_name",
    type: "text",
    placeholder: "Agent Last name",
    validation: {
      required: "Agent lastname is required",
    },
  },
  {
    label: "Phone Number",
    name: "phone",
    type: "tel",
    placeholder: "Phone number",
    validation: {
      required: "Phone is required",
    },
  },
  {
    label: "Upload Agent Photo",
    name: "profile_image",
    type: "upload",
    placeholder: "Agent Photo",
  },
  {
    label: "Real Estate License Number",
    name: "license",
    type: "text",
    placeholder: "Real Estate",
  },
  {
    label: "Brokerage Name",
    name: "brokerage_name",
    type: "text",
    placeholder: "Brokerage Name",
  },
  {
    label: "Brokerage Phone Number",
    name: "brokerage_phone",
    type: "tel",
    placeholder: "Brokerage Phone",
  },
  {
    label: "Upload Brokerage Logo",
    name: "brokerage_logo",
    type: "upload",
    placeholder: "Brokerage Logo",
  },
  // {
  //   label: "Real Estate Brokerage License Number",
  //   name: "brokerage_license",
  //   type: "text",
  //   placeholder: "Real Estate",
  // },
];
export const claimListingForm = {
  2: [
    {
      label: "Is there an Offer Date set for Seller to Review Offers?",
      name: "offer_date_available",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      validation: {
        required: "This field is required",
      },
    },
    {
      label: "Offer Date",
      name: "review_offer_date",
      type: "date",
      conditional: true,
      dependency: "offer_date_available",
      depValue: "yes",
    },
    {
      label:
        "Do you Authorize BPOHomes to display an Offer Date Countdown on BPOHomes.com for any potential Buyers and or the General Public to View?",
      name: "give_authorization",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      // validation: {
      //   required: "This field is required",
      // },
    },
  ],
  3: [
    {
      label:
        "Will the Seller View Offers at the time any such Offers are Presented?",
      name: "seller_view_offer",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      validation: {
        required: "This field is required",
      },
    },
    {
      label:
        "Do you Authorize BPOHomes to display an Offer Review Status on BPOHomes.com for any potential Buyers and or the General Public to View?",
      name: "display_offer_review_status",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      // validation: {
      //   required: "This field is required",
      // },
    },
    {
      label:
        "How many Hours or Days after Buyer offers are presented does Seller Request to review such Buyer offers?",
      name: "request_review_duration",
      type: "text_select",
      numberType: true,
      fullWidth: true,
      placeholder: "Hours/Days",
      // validation: {
      //   required: "This field is required",
      // },
      selectList: [
        { name: "Hours", value: "hours" },
        { name: "Days", value: "days" },
      ],
      selectListKey: "hours_days",
      selectListDefVal: "hours",
    },
    {
      label:
        "Would you Like the Days or Hours for Seller Response Displayed for Potential Buyers & or General Public Viewing?",
      name: "display_duration_response",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      // validation: {
      //   required: "This field is required",
      // },
    },
  ],
  4: [
    {
      label:
        "Is the Seller or Listing Broker offering to the Buyer Agent or Buyer Broker a concession?",
      name: "commission_available",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      validation: {
        required: "This field is required",
      },
    },
    {
      label:
        "Would you Like BPO HOMES to Email the Commission Rate Offered by the Seller or Seller’’s Broker to Buyer Broker and/or Buyer Brokers Agents upon Buyer Agent or Buyer Broker request?",
      name: "email_commission_rate",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      // validation: {
      //   required: "This field is required",
      // },
    },
    {
      label: "Who will pay the Buyer Broker?",
      name: "pay_buyer_broker",
      type: "select",
      list: [
        {
          name: "Seller",
          value: "seller",
        },
        {
          name: "Seller Brokerage",
          value: "sellerbrokerage",
        },
      ],
      // validation: {
      //   required: "This field is required",
      // },
    },
    // {
    //   label:
    //     "What is the Total Buyer Broker commission rate being offered for Buyer Broker Representation of Buyer? Select Commission Percentage Rate of Total Purchase price or Manually Enter the Fixed Amount.",
    //   name: "total_commision",
    //   type: "select",
    //   list: [
    //     {
    //       name: "10%",
    //       value: "10",
    //     },
    //     {
    //       name: "20%",
    //       value: "20",
    //     },
    //     {
    //       name: "Enter Manually",
    //       value: "manual",
    //     },
    //   ],
    //   // validation: {
    //   //   required: "This field is required",
    //   // },
    // },
    {
      label:
        "What is the Total Buyer Broker commission rate being offered for Buyer Broker Representation of Buyer? Select Commission Percentage Rate of Total Purchase price or Manually Enter the Fixed Amount.",
      name: "total_commision_rate",
      type: "text_select",
      numberType: true,
      fullWidth: true,
      placeholder: "Enter Percentage or Fixed Amount",
      // validation: {
      //   required: "This field is required",
      // },
      selectList: [
        { name: "Percentage (%)", value: "percentage" },
        { name: "Fixed Amount($)", value: "amount" },
      ],
      selectListKey: "amount_percentage",
      selectListDefVal: "percentage",
      // conditional: true,
      // dependency: "total_commision",
      // depValue: "manual",
    },
  ],
  5: [
    {
      label: "Is there a Lock Box at the Property?",
      name: "lock_box_available",
      type: "select",
      list: [
        {
          name: "Yes",
          value: "yes",
        },
        {
          name: "No",
          value: "no",
        },
      ],
      validation: {
        required: "This field is required",
      },
    },
    {
      label: "What is the type of Lock Box at the Property?",
      name: "lock_box_type",
      type: "select",
      list: [
        {
          name: "Supra",
          value: "supra",
        },
        {
          name: "Combo",
          value: "combo",
        },
        {
          name: "Other",
          value: "other",
        },
      ],
      // validation: {
      //   required: "This field is required",
      // },
    },
    {
      label: "Enter other Lock Box type",
      name: "other_lock_box_type",
      type: "text",
      placeholder: "Enter other type",
      conditional: true,
      dependency: "lock_box_type",
      depValue: "other",
    },
    {
      label: "Where is the Lock Box Location?",
      name: "lock_box_location",
      type: "text",
      placeholder: "Lock Location",
      // list: [
      //   {
      //     name: "Location A",
      //     value: "location_a",
      //   },
      //   {
      //     name: "Location B",
      //     value: "location_b",
      //   },
      //   {
      //     name: "Location C",
      //     value: "location_c",
      //   },
      // ],
      // validation: {
      //   required: "This field is required",
      // },
    },
    {
      label: "Provide Private Notes for Brokers & Agent to View",
      name: "private_notes",
      type: "textarea",
      placeholder: "Hint Text",
      // validation: {
      //   required: "This field is required",
      // },
    },
  ],
};
export const minimalistStyle = [
  {
    featureType: "administrative.land_parcel",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
];
export const bentoGridDesktop = [
  { cols: 2, rows: 2 },
  { cols: 1, rows: 1 },
  { cols: 1, rows: 1 },
  { cols: 1, rows: 1 },
  { cols: 1, rows: 1 },
  { cols: 2, rows: 1 },
  { cols: 2, rows: 2 },
  { cols: 2, rows: 1 },
  { cols: 4, rows: 2 },
  { cols: 1, rows: 2 },
  { cols: 1, rows: 2 },
  { cols: 2, rows: 1 },
  { cols: 2, rows: 1 },
];

export const bpoTerms = `By searching, you agree to the Terms of Use and Privacy Policy. Do
Not Sell My Personal Information. California DRE# 02190813. Our
Commitment to Accessibility. BPO HOMES is committed to making our
website accessible and user friendly to all. While we are constantly
working to improve, we welcome your feedback and improvement
requests. If you are having difficulty accessing or navigating our
website, or if you have any suggestions to improve accessibility. If
you wish to report an issue or seek an accommodation , please call
BPO Customer support for help at 1-888-616-5270`;

export const mlsListingTerms = `Property Information © 2026 MLSListings Inc. All rights reserved. Listing information is deemed reliable but not
guaranteed. Certain information contained herein is derived from information which is the licensed property of, and copyrighted
by, MLSListings Inc. The viewer acknowledges ownership and validity of its copyright. Information provided is for personal,
non-commercial use by a viewer with a bona fide interest in the purchase or sale of real estate of the type being offered via
this website or other electronic means. The viewer is prohibited from copying, redistributing or retransmitting any of the data
or information provided by MLSListing, Inc.`;

export const crmlListingTerms = `Based on information from California Regional Multiple Listing
Service, Inc. as of 2023. This information is for your personal,
non-commercial use and may not be used for any purpose other
than to identify prospective properties you may be interested in
purchasing. Display of MLS data is usually deemed reliable but
is NOT guaranteed accurate by the MLS. Buyers are responsible
for verifying the accuracy of all information and should
investigate the data themselves or retain appropriate
professionals. Information from sources other than the Listing
Agent may have been included in the MLS data. Unless otherwise
specified in writing, Broker/Agent has not and will not verify
any information obtained from other sources. The Broker/Agent
providing the information contained herein may or may not have
been the Listing and/or Selling Agent.`;

export const mlsListingSourceDisclaimer = `The data relating to real estate for sale on this display comes in part from the Internet Data Exchange program of the MLSListingsTM MLS system. Real estate listings held by brokerage firms other than BPO Homes are marked with the Internet Data Exchange and detailed information about them includes the names of the listing brokers and listing agents.`;

export const scriptArray = [
  {
    mainText: (
      <>
        Building Successful <br />
        Real Estate Agents Into Investors
      </>
    ),
    subText: (
      <>
        Only Brokerage Teaching Agents How to Become Real Estate Investors{" "}
        <br />
        Not Just Your Standard Agent
      </>
    ),
  },
  {
    mainText: (
      <>
        Don't be a Standard Agent
        <br />
        Become a Successful Investor
      </>
    ),
    subText: (
      <>Learn to Become a Successful Real Estate Investor with BPO Homes</>
    ),
  },
  {
    mainText: (
      <>
        Keep 100% of your Commission <br />
        BPO Realty Commission Caps Starting at Only 2k
      </>
    ),
    subText: <>(E&0 and Yearly Training Fee Not Included price)</>,
  },
  {
    mainText: (
      <>
        Access to Technology that <br />
        helps you Generate Listings, <br />
        BPO Reports and More..!!
      </>
    ),
    subText: (
      <>
        Access to technology that helps you generate BPO reports <br />
        (Broker Price Opinions).
      </>
    ),
  },
  {
    mainText: (
      <>
        Free Farm Marketing for Realty <br />
        Packages $149.00 and above
      </>
    ),
    subText: (
      <>
        Automated marketing tools to reach out to sellers in your target area
        <br />
        (available with higher-tier packages).
      </>
    ),
  },
  {
    mainText: (
      <>
        Cash Flow 4U Consistent Buyer to <br />
        Back your Real Estate Investment Deals
      </>
    ),
    subText: (
      <>
        Access to a network of buyers interested in purchasing your investment
        properties
      </>
    ),
  },
  {
    mainText: (
      <>
        Learn to Wholesale & <br />
        Subject to Transactions
      </>
    ),
    subText: (
      <>
        Access to technology that helps you generate BPO reports <br />
        (Broker Price Opinions).
      </>
    ),
  },
  {
    mainText: <>Free Deal Analyzer</>,
    subText: (
      <>
        Use a free tool to analyze potential real estate deals and assess their
        profitability.
      </>
    ),
  },
  {
    mainText: <>Farm Marketing</>,
    subText: {
      farmHeader: <>Farm Marketing Includes;</>,
      body: [
        "Yearly Custom Designed MMS Text to Sellers",
        "Yearly Custom Designed Emails to Sellers",
        "Yearly Direct Call Center Calling to Sellers",
      ],
    },
  },
  {
    mainText: <>Free Luxury Investor Websites</>,
    subText: (
      <>
        Get a free website designed to attract high-end real estate investors.
      </>
    ),
  },
  {
    mainText: <>Free GoHighLevel CRM</>,
    subText: (
      <>
        Free customer relationship management (CRM) software with built-in AI
        <br /> features to manage your leads and business.
      </>
    ),
  },
  {
    mainText: <>Investor List Organizer</>,
    subText: <>Organize and manage your list of potential investors.</>,
  },
  {
    mainText: (
      <>
        Fully Customizable <br />
        IDX Agent Website
      </>
    ),
    subText: {
      firstText: (
        <>
          Mater the Wholesaling and (Subject to) strategies and <br />
          earn up to 6Commissions on a Single Transaction
        </>
      ),
      secondText: (
        <>
          Set Up Your Very Own Luxury Customizable IDX Website to Set Up Buyer
          <br />
          Searches
        </>
      ),
    },
  },
  {
    mainText: (
      <>
        MDA Business Program with FREE <br />
        Coaching & Mentorship for Life
      </>
    ),
    subText: (
      <>
        Benefit from ongoing coaching and mentorship from <br />
        experienced professionals throughout your real estate career.
      </>
    ),
  },
  {
    mainText: <>Free Investor Agent Training</>,
    subText: (
      <>
        Access complimentary training programs specifically designed <br />
        for real estate investors.
      </>
    ),
  },
  {
    mainText: (
      <>
        Live Power Coaching with <br />
        CEO Joban Brown
      </>
    ),
    subText: (
      <>
        Receive exclusive coaching sessions with industry expert <br />
        Joban Brown (free of charge).
      </>
    ),
  },
  {
    mainText: (
      <>
        Full Training Center Contracts 
        <br />
        on BPO Tech
      </>
    ),
    subText: (
      <>
        Comprehensive training materials and resources <br />
        to help you master BPO technology.
      </>
    ),
  },
  {
    mainText: (
      <>
        Free CE Courses (In Applicable <br />
        States and Agent Tenure Rules Apply)
      </>
    ),
    subText: (
      <>
        Get access to free continuing education (CE) courses from
        <br />
        (availability depends on your state and agent license requirements).
      </>
    ),
  },
  {
    mainText: (
      <>
        Free Marketing Designs + Access to <br />
        BPO Homes Custom Design Team
      </>
    ),
    subText: (
      <>
        Receive free marketing materials and have the opportunity to work with
        <br />
        BPO Homes' design team.
      </>
    ),
  },
  {
    mainText: <>Free Digital Business Card</>,
    subText: (
      <>Get a digital business card to share your contact information easily.</>
    ),
  },
  {
    mainText: <>Free Social Media Advertisement</>,
    subText: (
      <>
        {/* Social media advertising services will be available in the future
        (coming soon). */}
      </>
    ),
  },
  {
    mainText: <>Low Cost Transaction Coordinators</>,
    subText: (
      <>Our Internal Transaction Coordinators ONLY $199 Per Transaction</>
    ),
  },
  {
    mainText: <>Revenue Share (Coming Soon)</>,
    subText: (
      <>
        Revenue sharing program where you can earn additional income based on
        <br /> Agent recruitment performance.
      </>
    ),
  },
  {
    mainText: (
      <>
        Company Stock Offerings
        <br />
        (Only Applicable when Rounds are Open)
      </>
    ),
    subText: (
      <>
        Potential opportunity to invest in BPO Homes' company stock <br />
        (subject to availability).
      </>
    ),
  },
  {
    mainText: <>Unlimited Buyer & Seller Leads</>,
    subText: (
      <>Get connected with clients interested in buying or selling estate</>
    ),
  },
];

export const brokerSections = [
  {
    id: 1,
    title: "Learn to Sell Real Estate the Right way",
    description:
      "We Teach You How to Sell Real Estate the Right way from the very beginning & provide you with all of the Following and more…",
    listItems: [
      "Real Estate Education Included",
      "Robust Step by Step Contracts & Disclosure Trainings",
      "Agent Marketing Trainings",
      "Learn to Farm the Right Way",
      "Piggy Backing (Piggyback Marketing Technique)",
      "Open House Trainings",
      "Real Estate Investment Training (Learn to Become a Real Estate Investor Not Just an Agent)",
    ],
    image: learnToSell,
    imagePosition: "right",
  },
  {
    id: 2,
    title: "Learn How to Analyze Deal with the Deal Analyzer Platform",
    description:
      "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
    listItems: [
      "Analyze Flips",
      "Analyze Remodels",
      "Analyze Additions",
      "Analyze Rentals",
      "Analyze Development Projects",
    ],
    image: learnToAnalyze,
    imagePosition: "left",
  },
  {
    id: 3,
    title: "FREE Agent Advertising any City of Agent's Choice",
    description:
      "An all-in-one customer service platform that helps you balance everything your customers need to be happy.",
    listItems: [
      "Agent Farming Marketing (Select BPO Realty Packages Apply)",
      "We Email Sellers",
      "We Text Sellers",
      "We Even Call Sellers on your Behalf as a part of your Team!!",
    ],
    image: advertiseAgents,
    imagePosition: "right",
  },
  {
    id: 4,
    title: "Be an Investor, Not Just an Agent",
    description:
      "THE ONLY Brokerage pushing you to become a real estate investor, not just a typical agent",
    listItems: [
      "Learn how to become A Real Estate Investor!",
      "Learn to Create Passive Income for the rest of your Life!",
      "Learn to Leverage Other People's Money!",
      "Your Goal is NOT to be a Real Estate AGENT Your Entire LIFE..",
    ],
    image: beAnInvestor,
    imagePosition: "left",
  },
];
export const brokerPerks = [
  "Unlimited Leads",
  "Free BPO Tech AI Tech",
  "Free GoHighLevel CRM",
  "Investor List Organizer Tool",
  "Free Luxury Investor Website",
  "Revenue Share",
  "Free Fully Customizable IDX Agent Website",
  "Free BPO Report Creation (Agents Can Dictate Price Charged for BPO Reports)",
  "Company Stock Offerings (Only Applicable when Rounds are Open)",
  "Cash Flow 4U Consistent Buyer for to Back your Real Estate Investment Deals $$$",
  "Transaction Coordinators`",
  "Free Digital Business Card",
  "Free Investor Agent Training",
  "Free Coaching & Mentorship for Life",
  "Free Power Coaching with Joban Brown",
  "Full Training Center Contracts on BPO Tech",
  "Free CE Courses (In Applicable States and Agent Tenure Rules Apply)",
  "Learn to Wholesale through a Wholesaler and Earn up to 6 commissions on a Single Transaction",
];
export const faqs = [
  {
    question: "Who is this internship program for?",
    answer:
      "This internship program is designed for aspiring real estate and brokers who are passionate about the industry and eager to learn from experienced professionals.",
  },
  {
    question: "What kind of experience will I gain?",
    answer:
      "You'll gain hands-on experience in various aspects of real estate, including property listing and marketing, client market research, and potentially assisting with open houses and showings.",
  },
  {
    question: "What skills will I develop?",
    answer:
      "You will help develop essential skills such as negotiation, marketing, client communication, market analysis, and problem-solving.",
  },
  {
    question: "How can I apply?",
    answer:
      "Click the 'Enroll NOW' buttons to join. Oh Yes! It is that simple.",
  },
];
